import axios from 'axios';
import {
  NEW_ANSWER_REQUEST,
  NEW_ANSWER_SUCCESS,
  NEW_ANSWER_FAIL,
  ANSWER_RESPONSE_REQUEST,
  ANSWER_RESPONSE_SUCCESS,
  ANSWER_RESET_REQUEST,
  ANSWER_RESET_SUCCESS,
  ANSWER_SAVE_FAIL,
  ANSWER_SAVE_REQUEST,
  ANSWER_SAVE_SUCCESS,
  ANSWER_LIST_REQUEST,
  ANSWER_LIST_SUCCESS,
  ANSWER_LIST_FAIL,
  ANSWER_CONTINUE_SUCCESS,
  ANSWER_CONTINUE_FAIL,
  ANSWER_CONTINUE_REQUEST,
  ANSWER_ADMIN_LIST_REQUEST,
  ANSWER_ADMIN_LIST_SUCCESS,
  ANSWER_ADMIN_LIST_FAIL,
  ANSWER_ADMIN_LOAD_REQUEST,
  ANSWER_ADMIN_LOAD_SUCCESS,
  ANSWER_ADMIN_LOAD_FAIL,
  ANSWER_RESPONSE_FAIL,
} from '../constants/answerConstants';

export const startNewQuiz = () => async (dispatch, getState) => {
  try {
    const {
      user: { userInfo },
    } = getState();

    dispatch({ type: NEW_ANSWER_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/answers`,
      null,
      config
    );

    dispatch({
      type: NEW_ANSWER_SUCCESS,
      payload: data,
    });

    localStorage.setItem('userAnswer', JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: NEW_ANSWER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetQuiz = () => async (dispatch, getState) => {
  dispatch({ type: ANSWER_RESET_REQUEST });

  const {
    userAnswer: { answer },
  } = getState();

  answer.lastAnsweredQuestionIndex = -1;
  const resetedResult = answer.result.map((r) => {
    return { ...r, points: 0 };
  });
  answer.result = resetedResult;

  dispatch({
    type: ANSWER_RESET_SUCCESS,
    payload: answer,
  });

  localStorage.setItem('userAnswer', JSON.stringify(answer));
};

export const continueQuiz = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ANSWER_CONTINUE_REQUEST,
    });

    const {
      user: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/answers/${id}`,
      config
    );

    if (data) {
      dispatch({
        type: ANSWER_CONTINUE_SUCCESS,
        payload: data,
      });

      localStorage.setItem('userAnswer', JSON.stringify(data));
    } else {
      throw new Error({
        message: 'Ocorreu um erro ao carregar seu questionário',
      });
    }
  } catch (error) {
    dispatch({
      type: ANSWER_CONTINUE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const loadAnswer = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ANSWER_ADMIN_LOAD_REQUEST,
    });

    const {
      user: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/admin/answers/${id}`,
      config
    );

    if (data) {
      dispatch({
        type: ANSWER_ADMIN_LOAD_SUCCESS,
        payload: data,
      });
    } else {
      throw new Error({
        message: 'Ocorreu um erro ao carregar seu questionário',
      });
    }
  } catch (error) {
    dispatch({
      type: ANSWER_ADMIN_LOAD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listUserAnswers = () => async (dispatch, getState) => {
  try {
    const {
      user: { userInfo },
    } = getState();
    dispatch({ type: ANSWER_LIST_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/answers`,
      config
    );

    dispatch({
      type: ANSWER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ANSWER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const answerQuestion =
  (answerId, questionId, optionIndex) => async (dispatch, getState) => {
    dispatch({ type: ANSWER_RESPONSE_REQUEST });

    try {
      const {
        user: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/answers/${answerId}`,
        {
          question_id: questionId,
          option_index: optionIndex,
        },
        config
      );

      dispatch({
        type: ANSWER_RESPONSE_SUCCESS,
        payload: data,
      });

      localStorage.setItem('userAnswer', JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: ANSWER_RESPONSE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const saveQuestion = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ANSWER_SAVE_REQUEST });

    const {
      user: { userInfo },
      userAnswer: { answer },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/answers/${answer._id}`,
      answer,
      config
    );

    dispatch({
      type: ANSWER_SAVE_SUCCESS,
      payload: data,
    });

    localStorage.setItem('userAnswer', JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: ANSWER_SAVE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listAllAnswers = () => async (dispatch, getState) => {
  dispatch({ type: ANSWER_ADMIN_LIST_REQUEST });
  try {
    const {
      user: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/admin/answers`,
      config
    );

    dispatch({
      type: ANSWER_ADMIN_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ANSWER_ADMIN_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
